import '@stimulus/polyfills'
import { Application, Controller } from 'stimulus'
import '@splidejs/splide/css'
import { Splide } from '@splidejs/splide'

const app = Application.start()

app.register('refosumu--companies-index--subsidies-section--component', class extends Controller {
  static targets = ['sliderSp']

  connect() {
    this.initializeSliders()
  }

  initializeSliders() {
    // 補助金カルーセル（SP）
    if (this.hasSliderSpTarget) {
      const spSlides = this.sliderSpTarget.querySelectorAll('.splide__slide')
      const spSlideCount = spSlides.length

      const spConfig = {
        type: 'loop',
        pagination: false,
        arrows: spSlideCount > 1,
        height: 'auto',
        fixedHeight: true,
        padding: '8%',
      }

      const spSplide = new Splide(this.sliderSpTarget, spConfig)
      spSplide.mount()
    }
  }
})
